import { setMessagesAsRead } from '../../actions/messages';
import { CHATBOT_ID } from '../../constants/chatbotId';
import { ResponseError } from '../../errors';
import {
  fetchMessagesRead,
  TMessagesReadRequest as TMessagesReadRequest_1,
  TMessagesReadResponse,
} from '../../repositories/chats/v1/messages/read';
import { TThunkAction, TThunkDispatch } from '../../types/redux/thunk';
import { ETelemetryEvents } from '../../types/telemetry';

// FIXME параметра messageIds нет в ручке, но чинить это будем позже
type TMessagesReadRequest = TMessagesReadRequest_1 & { messageIds: string[] };

/**
 * Пометить группу сообщений как прочитанные
 * @param parameters.chatId id чата
 * @param parameters.messageIds массив id сообщений
 */
/* istanbul ignore next */
export const markMessagesAsRead =
  (parameters: TMessagesReadRequest): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const {
      httpApi,
      logger,
      telemetry,
      custom: { messagesMap },
    } = context;
    const { chatId, messageIds } = parameters;

    if (chatId === CHATBOT_ID) {
      dispatch(setMessagesAsRead({ chatId, messageIds, messagesMap }));

      return;
    }

    try {
      const response: TMessagesReadResponse = await fetchMessagesRead({
        httpApi,
        parameters: { chatId },
        config: { requestConfig: { withCredentials: true } },
      });

      if (response.statusCode < 300) {
        telemetry.increment(ETelemetryEvents.MarkMessagesAsReadSuccess);

        dispatch(setMessagesAsRead({ chatId, messageIds, messagesMap }));
      } else {
        throw new ResponseError({
          domain: 'markMessagesAsRead',
          message: 'Failed to mark messages as read',
        });
      }
    } catch (ex) {
      telemetry.increment(ETelemetryEvents.MarkMessagesAsReadFail);
      logger.warning(ex, {
        domain: 'markMessagesAsRead',
        message: 'Failed to mark messages as read',
      });
    }
  };

let timeout: ReturnType<typeof setTimeout>;

const MARK_MESSAGE_AS_READ_TIMEOUT = 5000;

export const markMessagesAsReadWithTimeout = (parameters: TMessagesReadRequest) => (dispatch: TThunkDispatch) => {
  clearTimeout(timeout);

  timeout = setTimeout(() => {
    clearTimeout(timeout);
    dispatch(markMessagesAsRead(parameters));
  }, MARK_MESSAGE_AS_READ_TIMEOUT);
};
